import React, { useState, useEffect } from 'react';
import {CloseablePill} from "./closeablepill.js";


export function SearchResultCloseablePillList(props) {
  const { pills, onPillClose} = props

  const handlePillClose = (key, label) => {
    if (onPillClose) onPillClose(key, label);
  };

  return (
    <div className={`pillslistContainer`}>
      {pills.filter((pill) => pill.fk === "mission_facet_cs").length > 0 && <div className={`legendPrimary`}>
        <div className={`pillsContainer`}>
          {pills.filter((pill) => pill.fk === "mission_facet_cs").map((pill, index) => (
            <CloseablePill
              key={pill.id || Math.random().toString(36).substring(2, 9)}
              variant={"primary"}
              size={pill.size || "md"}
              fk = {pill.fk || "unknown"}
              onClose={() => handlePillClose(pill.fk, pill.label)}
            >
              {pill.label || pill}
            </CloseablePill>
          ))}
        </div>
      </div>}
      {
        pills.filter((pill) => pill.fk !== "mission_facet_cs").length > 0 &&
        pills.filter((pill) => "mission_facet_cs" === pill.fk).length > 0 &&
        pills.filter((pill) => pill.fk === "instrument_facet_cs").length > 0 &&
        <div className={`operationText`}> AND </div>
      }
      {pills.filter((pill) => pill.fk === "instrument_facet_cs").length > 0 &&
        <div className={`legendPrimary`}>
          <div className={`pillsContainer`}>
            {pills.filter((pill) => pill.fk === "instrument_facet_cs").map((pill, index) => (
              <CloseablePill
                key={pill.id || Math.random().toString(36).substring(2, 9)}
                variant={"primary"}
                size={pill.size || "md"}
                fk = {pill.fk || "unknown"}
                onClose={() => handlePillClose(pill.fk, pill.label)}
              >
                {pill.label || pill}
              </CloseablePill>)
              )
            }
          </div>
        </div>
      }
      {
        pills.filter((pill) => ["mission_facet_cs","instrument_facet_cs"].includes(pill.fk)).length > 0 &&
        pills.filter((pill) => pill.fk === "measurement_type_cs").length > 0 &&
        <div className={`operationText`}> AND </div>
      }
      {pills.filter((pill) => pill.fk === "measurement_type_cs").length > 0 &&
        <div className={`legendPrimary`}>
          <div className={`pillsContainer`}>
            {pills.filter((pill) => pill.fk === "measurement_type_cs").map((pill, index) => (
              <CloseablePill
                key={pill.id || Math.random().toString(36).substring(2, 9)}
                variant={"primary"}
                size={pill.size || "md"}
                fk = {pill.fk || "unknown"}
                onClose={() => handlePillClose(pill.fk, pill.label)}
              >
                {pill.label || pill}
              </CloseablePill>)
              )
            }
          </div>
        </div>
      }
      {
        pills.filter((pill) => ["mission_facet_cs","instrument_facet_cs","measurement_type_cs"].includes(pill.fk)).length > 0 &&
        pills.filter((pill) => pill.fk === "region").length > 0 &&
        <div className={`operationText`}> AND </div>
      }
      {pills.filter((pill) => pill.fk === "region").length > 0 &&
        <div className={`legendPrimary`}>
          <div className={`pillsContainer`}>
            {pills.filter((pill) => pill.fk === "region").map((pill, index) => (
              <CloseablePill
                key={pill.id || Math.random().toString(36).substring(2, 9)}
                variant={"primary"}
                size={pill.size || "md"}
                fk = {pill.fk || "unknown"}
                onClose={() => handlePillClose(pill.fk, pill.label)}
              >
                {pill.label || pill}
              </CloseablePill>)
              )
            }
          </div>
        </div>
      }
      {
        pills.filter((pill) => ["mission_facet_cs","instrument_facet_cs","measurement_type_cs", "regions"].includes(pill.fk)).length > 0 &&
        pills.filter((pill) => pill.fk === "cadence_cat").length > 0 &&
        <div className={`operationText`}> AND </div>
      }
      {pills.filter((pill) => pill.fk === "cadence_cat").length > 0 &&
        <div className={`legendPrimary`}>
          <div className={`pillsContainer`}>
            {pills.filter((pill) => pill.fk === "cadence_cat").map((pill, index) => (
              <CloseablePill
                key={pill.id || Math.random().toString(36).substring(2, 9)}
                variant={"primary"}
                size={pill.size || "md"}
                fk = {pill.fk || "unknown"}
                tooltip={pill.label}
                onClose={() => handlePillClose(pill.fk, pill.label)}
              >
                {pill.label || pill}
              </CloseablePill>)
              )
            }
          </div>
        </div>
      }
      {
        pills.filter((pill) => ["mission_facet_cs","instrument_facet_cs","measurement_type_cs", "regions","cadence_cat"].includes(pill.fk)).length > 0 &&
        pills.filter((pill) => pill.fk === "eras").length > 0 &&
        <div className={`operationText`}> AND </div>
      }
      {pills.filter((pill) => pill.fk === "eras").length > 0 &&
        <div className={`legendPrimary`}>
          <div className={`pillsContainer`}>
            {pills.filter((pill) => pill.fk === "eras").map((pill, index) => (
              <CloseablePill
                key={pill.id || Math.random().toString(36).substring(2, 9)}
                variant={"primary"}
                size={pill.size || "md"}
                fk = {pill.fk || "unknown"}
                onClose={() => handlePillClose(pill.fk, pill.label)}
              >
                {pill.label || pill}
              </CloseablePill>)
              )
            }
          </div>
        </div>
      }
      {
        pills.filter((pill) => ["mission_facet_cs","instrument_facet_cs","measurement_type_cs", "regions","cadence_cat", "eras"].includes(pill.fk)).length > 0 &&
        pills.filter((pill) => ["has_api","has_https","has_ftp","has_heliocloud_s3"].includes(pill.fk)).length > 0 &&
        <div className={`operationText`}> AND </div>
      }
      {pills.filter((pill) => ["has_api","has_https","has_ftp","has_heliocloud_s3"].includes(pill.fk)).length > 0 &&
        <div className={`legendPrimary`}>
          <div className={`pillsContainer`}>
            {pills.filter((pill) => ["has_api","has_https","has_ftp","has_heliocloud_s3"].includes(pill.fk)).map((pill, index) => (
              <CloseablePill
                key={pill.id || Math.random().toString(36).substring(2, 9)}
                variant={"primary"}
                size={pill.size || "md"}
                fk = {pill.fk || "unknown"}
                onClose={() => handlePillClose(pill.fk, pill.label)}
              >
                {pill.label || pill}
              </CloseablePill>)
              )
            }
          </div>
        </div>
      }
    </div>
  );
};
